import { css } from 'linaria';

export const projectDevelopmentSection = css`
  width: 100%;
  margin-bottom: 80px;

  @media (--only-tablet) {
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    margin-bottom: 48px;
  }
`;

export const projectDevelopmentTitle = css`
  margin-bottom: 16px;

  @media (--only-mobile) {
    margin-bottom: 8px;
  }
`;

export const projectDevelopmentDescription = css`
  width: 730px;
  margin-bottom: 32px;

  @media (--only-desktop) {
    width: 697px;
    margin-bottom: 24px;
  }

  @media (--to-desktop) {
    width: 100%;
    margin-bottom: 24px;
  }
`;

export const projectDevelopmentContainer = css`
  position: relative;
  display: flex;
  padding: 40px 56px;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);

  @media (--to-desktop) {
    padding: 40px;
  }

  @media (--to-desktop) {
    flex-direction: column;
  }

  @media (--only-mobile) {
    padding: 32px 16px;
    margin-right: -16px;
    margin-left: -16px;
    border-radius: unset;
  }
`;

export const scheduleBlock = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 270px;
  margin-right: 110px;

  @media (--only-desktop) {
    margin-right: 44px;
  }

  @media (--to-desktop) {
    order: 3;
    margin-right: 0;
  }

  @media (--only-mobile) {
    width: 100%;
  }
`;

export const scheduleInfoBlock = css`
  @media (--from-desktop) {
    margin-bottom: 24px;
  }
`;

export const developmentPrice = css`
  @media (--only-mobile) {
    margin-bottom: 12px;
  }
`;

export const developmentSchedule = css`
  display: flex;

  @media (--only-tablet) {
    margin-bottom: 32px;
  }

  @media (--only-mobile) {
    margin-bottom: 88px;
  }
`;

export const scheduleIcon = css`
  width: 20px;
  height: 20px;
  margin-right: 8px;

  @media (--only-mobile) {
    width: 16px;
    height: 16px;
  }
`;

export const developmentComposition = css`
  && {
    width: 422px;
    padding: 0;

    li {
      margin-bottom: 0;
    }

    @media (--only-desktop) {
      width: 345px;
    }

    @media (--to-desktop) {
      width: 100%;
      margin-bottom: 24px;
    }
  }
`;

export const developmentCompositionBlock = css`
  @media (--only-large-desktop) {
    margin-right: 62px;
  }
`;

export const developmentCompositionTitle = css`
  margin-bottom: 16px;
  font-weight: 500;

  @media (--only-desktop) {
    margin-bottom: 8px;
  }
`;

export const developmentExampleLink = css`
  && {
    height: 48px;

    @media (--only-tablet) {
      position: absolute;
      right: 100px;
      bottom: 40px;
      width: 202px;
      padding: 0;
    }

    @media (--only-mobile) {
      position: absolute;
      left: 16px;
      bottom: 100px;
      width: 202px;
      padding: 0;
    }
  }
`;
